export default function PreparationItemCategoriesDirective() {
  return {
    template: require('./preparation-item-categories.html'),
    scope: {
      auditId: '=',
      customerId: '=',
      coordinatorId: '=',
      auditPackageId: '=',
      hasActiveAuditPackage: '=',
      hasAuditPackageGenerationRequests: '=',
      auditIsActive: '=',
      canEdit: '=',
      canGeneratePackage: '=',
      canDownloadPackage: '=',
    },
    controller: 'PreparationItemCategoriesController',
    controllerAs: 'preparationItemCategoriesVM',
    bindToController: true,
    replace: true
  };
}
